export const TOUR_CARD_Z_INDEX = 2006;
